export enum PermissionType {
  Access = "Access",
  Share = "Share",
  CreateObject = "CreateObject",
  MetadataEdit = "MetadataEdit",
  Download = "Download",
  Comment = "Comment",
  Trash = "Trash",
}

export function getPermissionReadableName(permission: PermissionType): string {
  switch (permission) {
    case PermissionType.Access:
      return "View";
    case PermissionType.Comment:
      return "Comment";
    case PermissionType.CreateObject:
      return "Upload";
    case PermissionType.Download:
      return "Download";
    case PermissionType.MetadataEdit:
      return "Edit";
    case PermissionType.Share:
      return "Access";
    case PermissionType.Trash:
      return "Delete";
  }
}
